import { types } from '../types'

const initialState = {
  waiting: false,
  success: false,
  error: '',
  getCallTypesPending: false,
  getCallTypesError: null,

  getContactReportPending: false,
  getContactReportError: null,

  getCallReportPending: false,
  getCallReportError: null,
  callReport: null,



  contactReport: null,
  callTypes: [],

  //call direct
  getCallDirectReportPending: false,
  getCallDirectReportError: null,
  callDirectReport: null,


}

const callReportReducer = (state = initialState, { type, action, error }) => {
  switch (type) {


    case types.CALL_REPORT_REQUEST: {
      return {
        ...state,
        getCallReportPending: true,
        getCallReportError: null,

      }
    }
    case types.CALL_REPORT_SUCCESS: {
      return {
        ...state,
        getCallReportPending: false,
        callReport: action?.data

      }
    }
    case types.CALL_REPORT_ERROR: {
      return {
        ...state,
        getCallReportPending: false,
        getCallReportError: error,


      }
    }
    //Call direct**************************************************************************************************************s
    case types.CALL_REPORT_CALL_DIRECT_REQUEST: {
      return {
        ...state,
        getCallDirectReportPending: true,
        getCallDirectReportError: null,
      }
    }
    case types.CALL_REPORT_CALL_DIRECT_SUCCESS: {
      return {
        ...state,
        getCallDirectReportPending: false,
        callDirectReport: action?.data,
      }
    }
    case types.CALL_REPORT_CALL_DIRECT_ERROR: {
      return {
        ...state,
        getCallDirectReportPending: false,
        getCallDirectReportError: 'error',


      }
    }



    case types.GET_CONTACTS_REPORT_REQUEST: {
      return {
        ...state,
        getContactReportPending: true,
        getContactReportError: null,
        contactReport: {}

      }
    }
    case types.GET_CONTACTS_REPORT_SUCCESS: {


      return {
        ...state,
        getContactReportPending: false,
        contactReport: action.data

      }
    }
    case types.GET_CONTACTS_REPORT_ERROR: {
      return {
        ...state,
        getContactReportPending: false,
        getContactReportError: error,


      }
    }


    case types.GET_CUSTOMER_CALL_TYPES_REQUEST: {
      return {
        ...state,
        getCallTypesPending: true,
        getCallTypesError: null,
        callTypes: []

      }
    }
    case types.GET_CUSTOMER_CALL_TYPES_SUCCESS: {

      return {
        ...state,
        getCallTypesPending: false,
        callTypes: action.data

      }
    }
    case types.GET_CUSTOMER_CALL_TYPES_ERROR: {
      return {
        ...state,
        getCallTypesPending: false,
        getCallTypesError: error,


      }
    }


    case types.GET_CALL_REPORT_TO_EXPORT_REQUEST: {
      return {
        ...state,
        getCallReportPending: true,
        getCallREportToExportError: null,
        successGetDataExport: false,
        callREportToExport: undefined

      }
    }
    case types.GET_CALL_REPORT_TO_EXPORT_SUCCESS: {

      return {
        ...state,
        getCallReportPending: false,
        callREportToExport: action.data,

        successGetDataExport: true,

      }
    }
    case types.GET_CALL_REPORT_TO_EXPORT_ERROR: {
      return {
        ...state,
        getCallReportPending: false,
        getCallREportToExportError: error,


      }
    }


    case types.GET_CALL_REPORT_FILE_REQUEST: {
      return {
        ...state,
        getCallReportFilePending: true,
        getCallReportFileError: null,
        callReportFile: undefined

      }
    }
    case types.GET_CALL_REPORT_FILE_SUCCESS: {

      return {
        ...state,
        getCallReportFilePending: false,
        callReportFile: action.data,

      }
    }
    case types.GET_CALL_REPORT_FILE_ERROR: {


      return {
        ...state,
        getCallReportFilePending: false,
        getCallReportFileError: error,


      }
    }



    case types.CALL_REPORT_RESET_PROPS: {
      return {
        ...state,
        getCallTypesPending: false,
        getCallTypesError: null,
        getContactReportPending: false,
        getContactReportError: null,
        getCallReportPending: false,
        getCallReportError: null,
        successGetDataExport: false,

      }
    }

    default:
      return state
  }
}

export default callReportReducer;